let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cJYN0")).then(() => parcelRequire('azR8x'));